import Slider from 'antd/lib/slider'

import 'antd/lib/slider/style'

export * from 'antd/lib/slider'

export default Slider
